module.exports = __webpack_public_path__ + "static/media/load.73abf012.gif";